import { X } from "lucide-react";
import { taskListStyles } from "@/app/colors";
import { cn } from "@/lib/utils";
import type { TaskListColor } from "@/types/list";

interface TaskListBadgeProps extends React.HTMLAttributes<HTMLDivElement> {
    taskList: {
        id: number;
        name: string;
        color: TaskListColor;
    };
    showDelete?: boolean;
    onDelete?: () => void;
}

export function TaskListBadgeColorShape({ color }: { color: TaskListColor }) {
    const st = taskListStyles[color as keyof typeof taskListStyles];
    return <div className={cn("rounded size-3 border", st.background, st.border)}></div>;
}

export default function TaskListBadge({ taskList, className, showDelete, onDelete, ...props }: TaskListBadgeProps) {
    const st = taskListStyles[taskList.color as keyof typeof taskListStyles];
    return (
        <div
            data-colorkey={taskList.color}
            className={cn(
                "flex items-center pl-1 text-sm gap-1 font-normal rounded-sm",
                st.backgroundLight,
                st.text,
                className,
                !showDelete && "pr-1"
            )}
            {...props}
        >
            <TaskListBadgeColorShape color={taskList.color} />
            <div className="text-nowrap py-0.5 ml-1">{taskList.name}</div>
            {showDelete && (
                <button
                    type="button"
                    className="appearance-none px-0.5 h-full rounded-r-sm hover:text-orsane-primary hover:bg-black/10"
                    onClick={onDelete}
                >
                    <X className="size-3 min-w-3" />
                </button>
            )}
        </div>
    );
}
